<template>
  <div id="app">
    <router-view :style="{ ['padding-bottom']: $route.path == '/' || $route.path == '/classify' || $route.path == '/shopCart' || $route.path == '/User' ? 40 + 'px' : 0 }" />
    <div class="weixin-mask" v-if="showWeixinMask">
      <span class="text">点击右上角... ,选择用默认浏览器打开</span>
      <img src="./assets/images/指引.png" alt="">
    </div>
    <van-tabbar v-model="active" active-color="#ee0a24" inactive-color="#000" v-if="$route.path == '/' || $route.path == '/classify' || $route.path == '/shopCart' || $route.path == '/User'">
      <van-tabbar-item icon="home-o" replace to="/">首页</van-tabbar-item>
      <van-tabbar-item icon="apps-o" replace to="/classify">分类</van-tabbar-item>
      <van-tabbar-item icon="shopping-cart-o" replace to="/shopCart">购物车</van-tabbar-item>
      <van-tabbar-item icon="user-o" replace to="/User">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from './store'
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      active: Cookies.get('active') || 0,
      // 路由与Tabbar索引的映射
      routeIndexMap: {
        '/': 0,
        '/classify': 1,
        '/shopCart': 2,
        '/User': 3
      },
      showWeixinMask: false
      // active: 0
    }
  },
  // computed: {
  //   ...mapGetters(['active'])
  // },
  mounted() {
    // 初始化时根据当前路由设置active
    this.updateActiveFromRoute()
    // 监听路由变化
    this.$watch('$route', this.updateActiveFromRoute)
    this.checkWeixinBrowser()
  },
  methods: {
    updateActiveFromRoute() {
      const path = this.$route.path
      if (this.routeIndexMap[path] !== undefined) {
        this.active = this.routeIndexMap[path]
      }
    },
    checkWeixinBrowser() {
      const ua = navigator.userAgent.toLowerCase()
      const isWeixin = ua.indexOf('micromessenger') !== -1
      
      if(isWeixin) {
        this.showWeixinMask = true
      }
    },
    // onChange(index) {
    //   // this.$store.commit('user/SET_ACTIVE', index)
    //   this.active = index
    //   Cookies.set('active', index)
    // }
  }
}
</script>
<style lang="scss">
#app {
  height: 100%;
  width: 100%;
  .weixin-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.55);
    z-index: 999999;
    // display: flex;
    // align-items: center;
    // justify-content: flex-end;
    text-align: end;
    .text {
      color: #fff;
      font-size: 40px;
      // font-family: ; 
    }
    img {
      width: 15%;
      margin-right: 60px;
    }
  }
}
</style>
